import React, { PropsWithChildren } from 'react';
import { Heading } from '../../Heading/Heading';
import { useWidgetHeaderId } from '../Widget.utils';

type WidgetHeadingProps = PropsWithChildren<{
  hierarchy?: number;
}>;

export function WidgetHeading({ hierarchy = 2, children }: WidgetHeadingProps) {
  const widgetHeaderId = useWidgetHeaderId();

  return (
    <Heading hierarchy={hierarchy} className="widget-header__title" id={widgetHeaderId}>
      {children}
    </Heading>
  );
}
